import { defineStore } from 'pinia'
import { ref } from 'vue'

export type FairMobileImageFlowEntry = 'camera' | 'crop'
export type FairDesktopImageFlowEntry = 'upload' | 'crop'

export const useImageSearch = defineStore('imageSearch', () => {
  const imageBase64Data = ref<string | null>(null)
  const imageFile = ref<File | null>(null)
  const currentImageLink = ref<string | null>(null)
  const croppedImageLink = ref<string | null>(null)
  /** Full (pre-crop) image kept so photo-tap can reopen select-area. */
  const sourceImageBase64Data = ref<string | null>(null)
  const sourceImageLink = ref<string | null>(null)

  const isImageLoading = ref(false)

  const isImageSearchModalOpen = ref(false)
  /** Fair Home compact (<1024) camera + gallery + crop flow. */
  const isFairMobileImageFlowOpen = ref(false)
  const fairMobileImageFlowEntry = ref<FairMobileImageFlowEntry>('camera')
  /** Fair Home desktop (≥1024) Upload photo dialog — Figma `1:11529`…`1:11614`. */
  const isFairDesktopImageFlowOpen = ref(false)
  const fairDesktopImageFlowEntry = ref<FairDesktopImageFlowEntry>('upload')
  /** Paste/drop from SearchBar — consumed when a Fair image flow opens. */
  const pendingImageFile = ref<File | null>(null)

  const toggleImageSearchModal = () => {
    isImageSearchModalOpen.value = !isImageSearchModalOpen.value
  }

  function clearFairImageSearch() {
    imageBase64Data.value = null
    imageFile.value = null
    currentImageLink.value = null
    croppedImageLink.value = null
    sourceImageBase64Data.value = null
    sourceImageLink.value = null
  }

  function takePendingImageFile(): File | null {
    const file = pendingImageFile.value
    pendingImageFile.value = null
    return file
  }

  return {
    imageBase64Data,
    imageFile,
    currentImageLink,
    croppedImageLink,
    sourceImageBase64Data,
    sourceImageLink,
    isImageSearchModalOpen,
    isFairMobileImageFlowOpen,
    fairMobileImageFlowEntry,
    isFairDesktopImageFlowOpen,
    fairDesktopImageFlowEntry,
    pendingImageFile,
    toggleImageSearchModal,
    clearFairImageSearch,
    takePendingImageFile,
    isImageLoading,
  }
})
